"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es7.string.pad-start");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _CusromUpload = _interopRequireDefault(require("@/components/uploadImg/CusromUpload.vue"));
var _listingsExhibitionHall = require("@/api/listingsExhibitionHall");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ListingsExhibitionHall',
  components: {
    upload: _CusromUpload.default
  },
  data: function data() {
    return {
      loading: false,
      // 查询参数
      queryData: {
        name: '',
        status: null,
        unionCode: '',
        page: {
          page: 1,
          size: 20
        }
      },
      tableData: [],
      total: 0,
      // 渠道类型映射
      unionCodeMap: {
        'TB': '淘宝',
        'JD': '京东',
        'PDD': '拼多多',
        'WPH': '唯品会',
        'DY': '抖音'
      },
      // 编辑/新增弹窗
      dialogVisible: false,
      isAdd: true,
      ruleForm: {
        id: null,
        unionCode: '',
        name: '',
        sortNo: '',
        type: 0,
        transUrl: '',
        mainImage: '',
        timeRange: [],
        startTime: '',
        endTime: ''
      },
      rules: {
        unionCode: [{
          required: true,
          message: '请选择活动渠道',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        sortNo: [{
          required: true,
          message: '请输入活动排序',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '排序必须为数字',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择跳转类型',
          trigger: 'change'
        }],
        transUrl: [{
          validator: this.validateTransUrl,
          trigger: 'blur'
        }],
        mainImage: [{
          required: true,
          message: '请上传头图',
          trigger: 'change'
        }],
        timeRange: [{
          validator: this.validateTimeRange,
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    this.queryList();
  },
  methods: {
    // 校验活动时间
    validateTimeRange: function validateTimeRange(rule, value, callback) {
      if (!this.ruleForm.timeRange || this.ruleForm.timeRange.length !== 2) {
        callback(new Error('请选择活动时间'));
      } else {
        callback();
      }
    },
    // 校验跳转地址/ID
    validateTransUrl: function validateTransUrl(rule, value, callback) {
      if (!this.ruleForm.transUrl) {
        callback(new Error(this.ruleForm.type === 0 ? '请输入ID' : '请输入URL'));
      } else {
        callback();
      }
    },
    // 跳转类型变化
    onTypeChange: function onTypeChange() {
      this.ruleForm.transUrl = '';
      this.$refs.ruleForm && this.$refs.ruleForm.clearValidate('transUrl');
    },
    // 时间变化时触发校验
    onTimeChange: function onTimeChange(val) {
      if (val && val.length === 2) {
        this.ruleForm.startTime = val[0];
        this.ruleForm.endTime = val[1];
      } else {
        this.ruleForm.startTime = '';
        this.ruleForm.endTime = '';
      }
      this.$refs.ruleForm && this.$refs.ruleForm.validateField('timeRange');
    },
    // 查询列表
    queryList: function () {
      var _queryList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              params = {
                userId: this.$store.getters.userId,
                name: this.queryData.name || '',
                status: this.queryData.status,
                unionCode: this.queryData.unionCode || '',
                page: {
                  page: this.queryData.page.page,
                  size: this.queryData.page.size
                }
              };
              _context.n = 2;
              return (0, _listingsExhibitionHall.getSuperVenueList)(params);
            case 2:
              res = _context.v;
              this.tableData = res.data && res.data.records || [];
              this.total = res.data && res.data.total;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error(_t);
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function queryList() {
        return _queryList.apply(this, arguments);
      }
      return queryList;
    }(),
    // 查询按钮
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryList();
    },
    // 重置按钮
    onInitialize: function onInitialize() {
      this.queryData = {
        name: '',
        status: null,
        unionCode: '',
        page: {
          page: 1,
          size: 20
        }
      };
      this.queryList();
    },
    // 新增按钮
    onAdd: function onAdd() {
      var _this = this;
      this.isAdd = true;
      this.dialogVisible = true;
      this.$nextTick(function () {
        var now = new Date();
        var year = now.getFullYear();
        var month = String(now.getMonth() + 1).padStart(2, '0');
        var day = String(now.getDate()).padStart(2, '0');
        var startTime = "".concat(year, "-").concat(month, "-").concat(day, " 00:00:00");
        var endTime = '2099-12-31 23:59:59';
        Object.assign(_this.ruleForm, {
          id: null,
          unionCode: '',
          name: '',
          sortNo: '',
          type: 0,
          transUrl: '',
          mainImage: '',
          timeRange: [startTime, endTime],
          startTime: startTime,
          endTime: endTime
        });
      });
    },
    // 编辑按钮
    onEdit: function onEdit(row) {
      this.isAdd = false;
      this.ruleForm = {
        id: row.id,
        unionCode: row.unionCode || '',
        name: row.name || '',
        sortNo: row.sortNo !== undefined ? row.sortNo : '',
        type: row.type !== undefined ? row.type : 0,
        transUrl: row.transUrl || '',
        mainImage: row.mainImage || '',
        timeRange: row.startTime && row.endTime ? [row.startTime, row.endTime] : [],
        startTime: row.startTime || '',
        endTime: row.endTime || ''
      };
      this.dialogVisible = true;
    },
    // 删除按钮
    onDelete: function onDelete(row) {
      var _this2 = this;
      this.$confirm('确认删除该活动吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _listingsExhibitionHall.deleteSuperVenue)({
                id: row.id
              });
            case 1:
              _this2.$message.success('删除成功');
              _this2.queryList();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))).catch(function () {});
    },
    // 图片上传回显
    onPictureAddress: function onPictureAddress(data) {
      this.ruleForm[data.name] = data.pictureUrl;
    },
    // 弹窗关闭回调
    onDialogClose: function onDialogClose() {
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
    },
    // 提交表单
    submitForm: function submitForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(/*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(valid) {
          var confirmText;
          return (0, _regenerator2.default)().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                if (valid) {
                  confirmText = _this3.isAdd ? '确认新增该活动吗？' : '确认编辑该活动吗？';
                  _this3.$confirm(confirmText, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
                    var params, _t2;
                    return (0, _regenerator2.default)().w(function (_context3) {
                      while (1) switch (_context3.p = _context3.n) {
                        case 0:
                          _context3.p = 0;
                          params = {
                            name: _this3.ruleForm.name,
                            unionCode: _this3.ruleForm.unionCode,
                            type: _this3.ruleForm.type,
                            transUrl: _this3.ruleForm.transUrl,
                            mainImage: _this3.ruleForm.mainImage,
                            startTime: _this3.ruleForm.startTime,
                            endTime: _this3.ruleForm.endTime,
                            sortNo: Number(_this3.ruleForm.sortNo)
                          };
                          if (!_this3.isAdd) {
                            params.id = _this3.ruleForm.id;
                          }
                          _context3.n = 1;
                          return (0, _listingsExhibitionHall.saveSuperVenue)(params);
                        case 1:
                          _this3.$message.success(_this3.isAdd ? '新增成功' : '编辑成功');
                          _this3.dialogVisible = false;
                          _this3.queryList();
                          _context3.n = 3;
                          break;
                        case 2:
                          _context3.p = 2;
                          _t2 = _context3.v;
                          console.error(_t2);
                        case 3:
                          return _context3.a(2);
                      }
                    }, _callee3, null, [[0, 2]]);
                  }))).catch(function () {});
                }
              case 1:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    // 重置表单
    resetForm: function resetForm(formName) {
      this.$refs[formName] && this.$refs[formName].resetFields();
    },
    // 分页 - 页码变化
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.queryList();
    },
    // 分页 - 每页条数变化
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.queryData.page.page = 1;
      this.queryList();
    }
  }
};